import React from "react";
import "../css/callScreen.css";

export default function CallingScreen({ receiverName, onCancel }) {
  return (
    <div className="calling-screen">
      <div className="calling-content">
        <div className="calling-text">Calling {receiverName}…</div>
        <button className="cancel-call-btn" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </div>
  );
}